import { OnOrder } from 'services/api/pay';
import type { OrderInfo } from './components/PayModal';
import { logPricing } from './pricingLogger';
import { createAsaasOrderAndCheckout } from './asaas';

interface HandleOrderDependencies {
  orderAndPay: OnOrder;
  showPayModal: (info: OrderInfo) => void;
  onError: () => void;
}

export const handleOrder = (
  info: Parameters<OnOrder>[0],
  { orderAndPay, showPayModal, onError }: HandleOrderDependencies,
) => {
  const isSubscription = 'subscription' in info && info.subscription === true;
  const regionPackageId = 'regionPackageId' in info ? info.regionPackageId : undefined;
  const context = {
    requestId: info.idempotent,
    orderAction: info.orderAction,
    packageId: info.packageId,
    regionPackageId,
    currency: info.currency,
    durationNum: 'durationNum' in info ? info.durationNum : undefined,
    accountNum: 'accountNum' in info ? info.accountNum : undefined,
    payType: info.payType,
    subscription: isSubscription,
    quotedPayPrice: info.discountTotalPrice,
  };
  const startedAt = Date.now();
  if (regionPackageId) logPricing('order_requested', context);

  const isAsaas = info.payType === 'asaas';

  return (
    isAsaas
      ? createAsaasOrderAndCheckout(info, orderAndPay).then((result) => result.order)
      : orderAndPay(info)
  )
    .then((res) => {
      if (regionPackageId) {
        logPricing('order_succeeded', {
          ...context,
          elapsedMs: Date.now() - startedAt,
          orderCode: res?.orderCode,
          hasPaymentUrl: !!res?.paymentUrl,
        });
      }
      // Stripe 连续包月由订阅弹窗自行处理；Asaas 共用 PayModal 和订单 watcher。
      if (isSubscription && !isAsaas) {
        return res;
      }
      showPayModal({
        ...info,
        ...res,
      });
      return res;
    })
    .catch((error) => {
      if (regionPackageId) {
        logPricing('order_failed', { ...context, elapsedMs: Date.now() - startedAt }, error);
      }
      onError();
      // 订阅流程需要由调用方收尾 loading、轮询和支付弹窗状态。
      if (isSubscription) {
        throw error;
      }
    });
};
